import type { Organization } from "@/models/organization"
import type {
  BillPeriodListApiQueryOptions,
  BillPeriodListResponse,
} from "@/services/core-api/types"
import { httpClient, toHttpError } from "@/utils/api"

export interface GetBillPeriodsParams {
  apiQueryOptions: BillPeriodListApiQueryOptions
  organizationId: Organization["id"]
}

export const getBillPeriods = async ({
  apiQueryOptions,
  organizationId,
}: GetBillPeriodsParams): Promise<BillPeriodListResponse> => {
  try {
    const response = await httpClient.get<BillPeriodListResponse>(
      `/api/v1/organizations/${organizationId}/bill-periods`,
      {
        params: apiQueryOptions,
      }
    )

    return response.data
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}
